<template>
  <div :class="['v-signature', isPopupForMobiles ? 'signature-popup': '']" data-vv-value-path="model" :data-vv-as="label">

    <div>
      <label v-if="label">{{label}}</label>
      <i v-if="!isDirtyLocal" class="v-signature__info db-nl">({{ signatureInfo }})</i>
    </div>

    <button v-if="allowEdit" class="theme-btn theme-btn--white-outlined" @click.prevent="openPopupForMobiles">{{model ? editSignature : addSignature}} </button>
    <button v-else-if="!model" class="theme-btn theme-btn--white-outlined" @click.prevent="openPopupForMobiles">{{ addSignature}} </button>


    <div class="v-signature-content">
      <i class="signature-popup__info-icon hide-hlp" ref="infoIcon"></i>
      <div class="v-signature-block">
        <div v-if="!isDirtyLocal && !mobileView" @mouseup="save" @touchend="save" class="canvas-holder-wrap">
          <vueSignature :class="['canvas-holder', !!errors.has(name) ? 'v-input__error--border': '']" ref="signature" :sigOption="option" @mouseup="save" @touchend="save"></vueSignature>
        </div>

        <div v-if="!isDirtyLocal && isPopupForMobiles" @mouseup="save" @touchend="save" class="canvas-holder-wrap">
          <vueSignature :class="['canvas-holder canvas-holder--mobile', !!errors.has(name) ? 'v-input__error--border': '']" ref="signature" :sigOption="option"></vueSignature>
        </div>
      </div>
      <div class="v-signature-bottom">
        <div>
          <button class="theme-btn theme-btn--white-outlined" @click.prevent="clear">{{clearSignature}}</button>
          <span class="v-input__error" v-if="errors.has(name)" style="display: inline;">
            {{ errors.first(name) }}
          </span>
        </div>
        <button class="theme-btn theme-btn--primary" @click.prevent="triggerSaveAndCloseBtn">{{saveAndClose}}</button>
        <button class="theme-btn theme-btn--white-outlined" @click.prevent="closePopup">{{ locales && locales.common && locales.common.close }}</button>
      </div>
    </div>

    <img v-if="isDirtyLocal" :src="model" @mouseup.stop="" @touchend.stop="" :class="[model ? '': 'no-sign-saved']">
    <input type="hidden" :name="name" v-model="model">
    <div class="form__field-error" v-if="errors.has(newName)">
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
  import field from '../mixins/field'
  import sweetalert from "sweetalert";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        model: this.value,
        isDirtyLocal: !!this.value,
        option: {
          penColor: this.color
        },
        isPopupForMobiles: false,
        mobileView: window.innerWidth < 1279 ? true : false,
        viewportMeta: document.querySelector('meta[name="viewport"]')
      };
    },
    methods: {
      save() {
        let that = this;

        if (window.matchMedia("(orientation: portrait)").matches) {
          sweetalert(
            window.app.locales.common.info,
            that.infoMessage,
            "info").then(() => {
              that.$refs.signature.clear();
              that.model = '';
            });
        } else {
          if (this.$refs.signature && !this.$refs.signature.isEmpty()) {
            this.model = this.$refs.signature.save('image/svg+xml');
          }
        }
      },
      clear() {
        if (this.$refs.signature) {
          this.$refs.signature.clear();
        }

        this.model = '';
        this.isDirtyLocal = false;

        let element = document.getElementById('sendAgreementBtn');

        if (typeof (element) != 'undefined' && element != null) {
          element.style.display = "none";
        }
      },
      triggerSaveAndCloseBtn() {
        let selector = document.getElementById('triggerSaveBtn') || document.getElementById('submitBtn'),
          page = document.querySelector('body');

        if (selector) {
          if (this.$refs.signature.isEmpty()) {
            this.model = '';
          } else {
            selector.removeAttribute('disabled');
            selector.click();
          }

          this.isPopupForMobiles = false;

          this.viewportMeta.content = 'width=device-width, initial-scale=1.0, minimum-scale=1.0, shrink-to-fit=no';

          if (page) {
            const body = document.body,
              scrollY = body.style.top;

            page.classList.remove('signature-popup-is-active')
            body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
          };
        }
      },
      openPopupForMobiles() {
        this.isPopupForMobiles = true;
        this.mobileView = true;
        this.clear();

        let page = document.querySelector('body');

        if (page) {
          page.classList.add('signature-popup-is-active')
        }

        const scrollY = document.documentElement.style.getPropertyValue('--scroll-y'),
          body = document.body;

        body.style.top = `-${scrollY}`;
      },
      closePopup() {
        this.isPopupForMobiles = false;
        this.mobileView = true;
        this.clear();

        let page = document.querySelector('body');

        if (page) {
            const body = document.body,
              scrollY = body.style.top;

            page.classList.remove('signature-popup-is-active')
            body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        };
      },
      resizeCanvas() {
        const canvas = this.$refs.signature.$el.children[0];
        const ratio =  Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);
        this.$refs.signature.clear();
      }
    },
    created() {
      let that = this;

      this.$root.$on('sign-is-saved', () => {
        this.isDirtyLocal = true;
      });

      window.addEventListener('resize', () => {
        if (window.innerWidth < 1279) {
          that.mobileView = true;
        } else {
          that.mobileView = false;
          that.isPopupForMobiles = false;
        }
      });

      window.addEventListener('scroll', () => {
        document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
      });
    },
    mounted() {
      let that = this;

      $(window).on('orientationchange', function () {
          if (that.$refs.signature) {
            if (window.matchMedia("(orientation: portrait)").matches) {
                that.$refs.signature.clear();
                that.model = '';
            }
            if (that.$refs.signature.$el) {
                that.resizeCanvas()
            }
        }
      });

      $(window).on('resize orientationchange', function () {
        if (!that.isDirtyLocal &&
                   that.isPopupForMobiles &&
                   navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {

            if (that.viewportMeta) {
                that.viewportMeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0';
            }
        }
      });
    },
    computed: {
      ...mapGetters(["locales"]),
    },
    props: {
      label: {
        default: '',
        type: String
      },
      name: {
        default: '',
        type: String
      },
      value: {
        default: '',
        type: String
      },
      color: {
        default: "rgb(0, 0, 0)",
        type: String
      },
      addSignature: {
        default: 'Add signature',
        type: String
      },
      editSignature: {
        default: 'Edit signature',
        type: String
      },
      clearSignature: {
        default: 'Clear',
        type: String
      },
      saveAndClose: {
        default: 'Save and close',
        type: String
      },
      allowEdit: {
        default: true,
        type: Boolean
      },
      signatureInfo: {
        default: '',
        type: String
      },
      infoMessage: {
        default: '',
        type: String
      }
    },
    mixins: [field],
    watch: {
      value(newValue) {
        this.model = newValue
      }
    }
  };
</script>
